import styled from 'styled-components/native';
import { themes } from '../../design/colors';
import { Feather as IconsFA } from '@expo/vector-icons';
// import { Title, Body } from '../Text';

export const TitleText = styled.Text`
  font-weight: bold;
  font-size: 25px;
  color: ${themes.colors.black};
  margin-bottom: 16px;
`;

export const BodyText = styled.Text`
  color: ${themes.colors.gray3};
  margin-bottom: 32px;
`;

export const HeaderBottomSheet = styled.View`
  margin: 0 0 15px 0;
`;

export const ButtonIcon = styled.TouchableOpacity`
  width: 24px;
  height: 24px;
`;

export const IconFA = styled(IconsFA)`
    color: ${themes.colors.primary};
`;

// Usados só na variante Web do BottomSheet (ver index.tsx): o Modalize
// depende de medições nativas (measure/UIManager) que não funcionam direito
// no react-native-web, deixando o conteúdo com altura 0 e só o overlay visível.
export const WebOverlay = styled.View`
  flex: 1;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: flex-end;
  align-items: stretch;
`;

export const WebSheet = styled.View`
  background-color: ${themes.colors.white};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
  width: 100%;
  max-width: 480px;
  align-self: center;
`;
